<template>
  <div>
    <p v-if="isLoading" class="state text-subtle">Hämtar kompletteringar...</p>
    <p v-else-if="error" class="state error-text">{{ error }}</p>

    <template v-else>
      <div class="view-header">
        <div>
          <h1>Kompletteringar</h1>
          <p class="text-subtle">Öppna förfrågningar som behöver besvaras med en komplettering.</p>
        </div>
        <p class="text-subtle">{{ applicationAdditionRequests.length }} öppna förfrågningar</p>
      </div>

      <div v-if="applicationAdditionRequests.length" class="request-grid">
        <component
          :is="applicationAdditionRequestComponents[request.type]"
          v-for="request in applicationAdditionRequests"
          :key="request.requestId"
          :request="request"
          :application-id="applicationId"
        />
      </div>

      <div v-else class="empty-box">
        <h2>Inga öppna förfrågningar</h2>
        <p class="empty-hint text-subtle">Det finns inga efterfrågade kompletteringar att hantera just nu.</p>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { applicationAdditionRequestComponents } from './applicationAdditionRequestComponents'
import { useApplicationAdditions } from './composables/useApplicationAdditions'

const { application, applicationAdditionRequests, isLoading, error } = useApplicationAdditions()

const applicationId = computed(() => application.value?.id ?? '')
</script>

<style scoped lang="scss">
.state {
  padding: var(--space-16);
}

.view-header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-8);
  margin-bottom: var(--space-16);
}

.request-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-16);
}

@media (min-width: 64rem) {
  .request-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.empty-box {
  padding: var(--space-32);
  border: 1px dashed var(--color-border-default);
  border-radius: var(--radius-md);
  background-color: var(--color-canvas-default);
  text-align: center;
}

.empty-hint {
  margin-top: var(--space-4);
}
</style>
